/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */

import Alpine from "alpinejs";
import AOS from "aos";

// Alpine.prefix('data-x-');
window.Alpine = Alpine;
Alpine.start();

// animation
AOS.init();

document.addEventListener("DOMContentLoaded", function () {
    // document.addEventListener("scroll", updateCursorColor);
    document.addEventListener("mousemove", updateCursorColor);
    // Initial cursor color update
    updateCursorColor({ target: null }); // Pass an event with null target to set the initial cursor style

    // Add event listener to update header color on scroll
    window.addEventListener("scroll", updateHeaderColor);
    // Initial header color update
    updateHeaderColor();

    window.addEventListener("resize", setAbsolutePositionForPattern);
    setAbsolutePositionForPattern();

    // Add event listener to update sideheader on work listing for change color on scroll
    window.addEventListener("scroll", updateNavColor);
    updateNavColor();
});

function updateNavColor() {
    let activeSection = null;
    let sectionLinks = document.querySelectorAll(".section-link");

    sectionLinks.forEach((link) => {
        let href = link.getAttribute("href");

        if (href && href.length > 1) {
            let sectionId = href.substring(1);
            let targetSection = document.getElementById(sectionId);

            if (targetSection) {
                let sectionRect = targetSection.getBoundingClientRect();
                let padding = 350;
                if (sectionRect.top - padding <= 0 && sectionRect.bottom >= 0) {
                    activeSection = sectionId;
                }
            }
        }

        sectionLinks.forEach((link) => {
            let sectionId = link.getAttribute("href").substring(1);
            link.classList.toggle(
                "text-gold-finch-500",
                sectionId === activeSection
            );
        });
    });
}

// Function to update header color based on section visibility
function updateHeaderColor() {
    let header = document.querySelector("header");
    let sidebarNav = document.querySelector(".sidebarNav");
    let sections = document.querySelectorAll(".pageSection");

    sections.forEach((section) => {
        let sectionRect = section.getBoundingClientRect();
        let headerRect = header.getBoundingClientRect();

        if (
            sectionRect.top <= headerRect.height / 2 &&
            sectionRect.bottom >= headerRect.height / 2
        ) {
            // Check if the middle of the section is within the header's space
            if (section.classList.contains("dark")) {
                if (
                    section.classList.contains("dark") &&
                    section.classList.contains("yellow")
                ) {
                    header.classList.add("is-published");
                }
                header.style.color = "#ffffff"; // Change header to light color
                if (sidebarNav) {
                    sidebarNav.classList.add("is-published");
                    sidebarNav.style.color = "#ffffff"; // Change header to light color
                }
            } else {
                header.style.color = "#222121"; // Change header to transparent
                header.classList.remove("is-published");
                if (sidebarNav) {
                    sidebarNav.style.color = "#222121"; // Change header to transparent
                    sidebarNav.classList.remove("is-published");
                }
            }
            return;
        }
    });
}

// Function to update cursor color based on section visibility
function updateCursorColor(event) {
    let body = document.body;
    let sections = document.querySelectorAll(".pageSection");

    // Check if the cursor is over any section with the "dark" class
    let isOverYellowSection = Array.from(sections).some(
        (section) =>
            section.contains(event.target) &&
            section.classList.contains("yellow")
    );
    let isOverYellowFirstChild = Array.from(sections).some((section) => {
        let firstChild = section.querySelector(":scope > .yellow");
        return (
            section.classList.contains("dark") &&
            firstChild &&
            firstChild.contains(event.target)
        );
    });

    // Duplication of code
    /*let isOverLightSection = Array.from(sections).some(section => section.contains(event.target) && section.classList.contains("light"));
    let isOverDarkSection = Array.from(sections).some(section => section.contains(event.target) && section.classList.contains("dark"));
    if (((isOverLightSection) || (isOverDarkSection && !isOverYellowSection)) && !isOverYellowFirstChild) {
        body.classList.remove("cursor-fancy-white");
        body.classList.add("cursor-fancy");
    }*/

    // Add or remove the "cursor-fancy-white" class based on the cursor position
    if (isOverYellowFirstChild || isOverYellowSection) {
        body.classList.remove("cursor-fancy");
        body.classList.add("cursor-fancy-white");
    } else {
        body.classList.remove("cursor-fancy-white");
        body.classList.add("cursor-fancy");
    }
}

function setAbsolutePositionForPattern() {
    let item = document.querySelector(".footer-svg");
    if (item) {
        let width = item.offsetWidth;
        let height = item.offsetHeight;

        item.style.top = "-" + (height * 132.5) / 1000 / 2 + "px";
        // item.style.left = '-' + (((width*170)/1000)) + 'px';
        // item.style.right = '';
        if (window.innerWidth <= 767) {
            item.style.right = "-" + (width * 420) / 370 + "px";
            item.style.left = "";
        } else {
            item.style.left = "-" + (width * 170) / 1000 + "px";
            item.style.right = "";
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let loaderWrapper = document.querySelector(".loader-wrapper");
    if(loaderWrapper) {
        loaderWrapper.style.display = "none";

        let loaderWrapperCookie = 'splashScreen';
        setCookie(loaderWrapperCookie, 1, 1);
    }

});

function setCookie(cname, cvalue, exdays, cpath = "/") {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";" + "path=" + cpath + ";secure;SameSite=Strict";
}

var forms = document.querySelectorAll("[data-freeform-tailwind]");

forms.forEach(function(form) {
    form.addEventListener('freeform-ready', (event) => {
        const instance = event.target.freeform;
        instance.setOption("errorClassBanner", ["bg-red-100", "border", "border-red-400", "text-red-700", "px-4", "py-3", "rounded", "relative", "mb-4", "-mx-1", "font-mono", "tracking-1"]);
        instance.setOption("errorClassList", ["errors", "text-red-500", "text-eyebrows", "mt-2", "font-mono", "tracking-1"]);
        instance.setOption("errorClassField", ["border-red-500"]);
        instance.setOption("successClassBanner", ["hidden", "bg-green-100", "border", "border-green-500", "text-green-700", "px-4", "py-3", "rounded", "relative", "mb-4"]);
    });

    form.addEventListener('freeform-render-success', (event) => {
        const modal = document.querySelector('.form-success-modal');
        const message = form.dataset.successMessage;
        const modalClose = document.querySelector('.close-btn');

        if (modal) {
            modal.classList.remove("opacity-0", "-z-[1]");
            modal.classList.add("opacity-100", "z-20");
            modal.querySelector('.form-success-message').innerHTML = message;
        }

        if (modalClose) {
            modalClose.addEventListener('click', function () {
                modal.classList.add("opacity-0", "-z-[1]");
                modal.classList.remove("opacity-100", "z-20");
            });
        }
    });

    form.addEventListener("freeform-stripe-appearance", function(e) {
        e.elementOptions.appearance = Object.assign(e.elementOptions.appearance, {
            variables: {
                colorPrimary: "#0d6efd",
                fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                fontSizeBase: "16px",
                spacingUnit: "0.2em",
                tabSpacing: "10px",
                gridColumnSpacing: "20px",
                gridRowSpacing: "20px",
                colorText: "#212529",
                colorBackground: "#ffffff",
                colorDanger: "rgb(239 68 68)",
                borderRadius: "5px"
            },
            rules: {
                ".Tab, .Input": {
                    border: "1px solid rgb(148 163 184)",
                    boxShadow: "none"
                },
                ".Tab:focus, .Input:focus": {
                    border: "1px solid #0b5ed7",
                    boxShadow: "none",
                    outline: "0",
                    transition: "border-color .15s ease-in-out"
                },
                ".Label": {
                    fontSize: "16px",
                    fontWeight: "500"
                }
            }
        });
    });

    form.addEventListener("freeform-on-submit", function(e) {
        var submittedFormId = e.form.getAttribute("data-id");

        forms.forEach(function(otherForm) {
            var otherFormId = otherForm.getAttribute("data-id");

            if (submittedFormId !== otherFormId) {
                otherForm.querySelectorAll("[data-field-errors]").forEach(el => el.remove());
                otherForm.querySelectorAll(".freeform-input").forEach(el => {
                    el.classList.remove("border-red-500");
                });
            }
        });
    });
});

